import { render } from "./MedidaRef.vue?vue&type=template&id=4a06d7c3&scoped=true"
import script from "./MedidaRef.vue?vue&type=script&lang=js"
export * from "./MedidaRef.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=4a06d7c3&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a06d7c3"]])

export default __exports__